export default "__VITE_ASSET__BuIouqsv__"